// extracted by mini-css-extract-plugin
module.exports = {"container":"ClipboardButton_container__qqXW6","tooltip":"ClipboardButton_tooltip__0tQRa"};